import React, { useEffect, useState } from "react";
import { Table, Checkbox, Button, Tooltip, Spin, Avatar, Modal, message, Tag } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, UserOutlined } from "@ant-design/icons";
import { MdBlockFlipped, MdCheckCircle } from "react-icons/md";
import "../buyer/Indivisual.css";


import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../../common/Pagination";
import { Link, useNavigate } from "react-router-dom";
import { getAllManager, updateManagerStatus } from "../../../api/AdminRequest";



const ManagerList = () => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false);

  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);

  const [user, setUser] = useState([]); // Update initial state to '

  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleManagerAction = (data) => {
    navigate('/manager-edit', { state: data })
  };
  const handleSingleView = (id) => {
    navigate("/manager-single-view", { state: id })

  };
  const handleSelectUser = (user) => {
    setSelectedUsers((prevSelectedUsers) => {
      const isSelected = prevSelectedUsers.some(
        (selectedUser) => selectedUser._id === user._id
      );
      if (isSelected) {
        return prevSelectedUsers.filter(
          (selectedUser) => selectedUser._id !== user._id
        );
      } else {
        return [...prevSelectedUsers, user];
      }
    });
  };

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllManager({
          // q: searchUser,
          page: currentPage,
          limit: limit,
        });

        if (data?.success) {
          setUser(data?.managerList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidsCall();
  }, [limit, currentPage, trigger]);


  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  //  ------- FUNCTION DELETE AND APPROVE------------
  const handleManagerStatus = async (id, status) => {
    try {
      Modal.confirm({
        title: `Confirm ${status.charAt(0).toUpperCase() + status.slice(1)
          } Status`,
        content: `Are you sure you want to ${status} this manager? This action cannot be undone.`,
        onOk: async () => {
          try {
            const { data } = await updateManagerStatus(id, status);
            if (data.success) {
              message.success("status updated succesfully")
              setTrigger(!trigger);

            }
          } catch (error) {
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
              ErrorLogout(error);
            }
          }
        },
        onCancel: () => {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.log(error);
      console.log(error.message);
      if (error?.response?.status === 401) {
        ErrorLogout(error);
      }
    }
  };

  const columns = [
    {
      title: "Select",
      dataIndex: "select",
      width: 60,
      render: (_, record) => (
        <Checkbox
          checked={selectedUsers.some((user) => user._id === record._id)}
          onChange={() => handleSelectUser(record)}
        />
      ),
    },
    {
      title: (
        <div className="flex items-center">
          Manager Name
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div className="flex items-center">
          <Avatar
            src={record.profileImage}
            icon={<UserOutlined />}
            className="mr-2"
          />
          <span className="text-[#313131] text-[13px] font-medium">{text}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center">
          Roles
        </div>
      ),
      dataIndex: "roleDetails",
      key: "role",
      render: (data) => <span>{data.role.join(", ")}</span>,
    },
    {
      title: (
        <div className="flex items-center">
          State

        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (data) => <span>{data.state.join(", ")}</span>,
    },

    {
      title: (
        <div className="flex items-center">
          District
        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (data) => <span>{data.district.join(", ")}</span>,
    },
    {
      title: (
        <div className="flex items-center">
          City
        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (data) => <span>{data.city.join(", ")}</span>,
    },
    {
      title: (
        <div className="flex items-center">
          Status
        </div>
      ),
      dataIndex: "status",
      key: "status",
      render: (data) => <span><Tag className="w-16 flex justify-center" color={data === 'active' ? 'green' : "gold"}>{data}</Tag></span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const isActive = record.status === "active";
        return (
          <div className="flex items-center gap-2">
            <Tooltip title="View Details">
              <button
                onClick={() => handleSingleView(record._id)}
                className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
              >
                <EyeOutlined style={{ fontSize: 16 }} />
              </button>
            </Tooltip>

            <Tooltip title="Edit Manager">
              <button
                onClick={() => handleManagerAction(record)}
                className="w-8 h-8 flex items-center justify-center bg-yellow-50 text-yellow-600 rounded-lg hover:bg-yellow-600 hover:text-white transition-all shadow-sm border border-yellow-100"
              >
                <EditOutlined style={{ fontSize: 16 }} />
              </button>
            </Tooltip>

            <Tooltip title={isActive ? "Deactivate" : "Activate"}>
              <button
                onClick={() =>
                  handleManagerStatus(record._id, isActive ? "deactive" : "active")
                }
                className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all shadow-sm border ${isActive
                    ? "bg-orange-50 text-orange-600 border-orange-100 hover:bg-orange-600 hover:text-white"
                    : "bg-green-50 text-green-600 border-green-100 hover:bg-green-600 hover:text-white"
                  }`}
              >
                {isActive ? <MdBlockFlipped size={16} /> : <MdCheckCircle size={16} />}
              </button>
            </Tooltip>

            <Tooltip title="Delete Manager">
              <button
                onClick={() => handleManagerStatus(record._id, "delete")}
                className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm border border-red-100"
              >
                <DeleteOutlined style={{ fontSize: 16 }} />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (

    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <>
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6 mt-2">
          <div className="text-left w-full">
            <h1 className="text-xl font-bold text-gray-800">Managers</h1>
            <p className="text-sm text-gray-500">Manage your system administrators and their roles.</p>
          </div>
          <div className="w-full lg:w-auto">
            <Link
              to="/manager-create"
              className="flex items-center justify-center bg-[#1955EB] text-white px-8 h-10 rounded-lg font-bold hover:bg-blue-700 transition-all shadow-lg hover:shadow-blue-200 active:scale-95 text-sm"
            >
              + Create Manager
            </Link>
          </div>
        </div>
        <Spin spinning={loader}>
          <Table
            pagination={false}
            columns={columns}
            dataSource={user}
            className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            limit={limit}
            totalItem={totalItems}
            onPageChange={handlePageChange}
            handleLimit={handleLimit}
          />
        </Spin>
      </>
    </div>
  );
};

export default ManagerList;
